import axios from './axiosInstances/axiosInstance';

export const getProductModifiers = (productId) => {
  return axios.get(`/products/${productId}/modifiers`);
};
